import comprehensiveAccountingDataService from './comprehensiveAccountingDataService';
import accountingService from './accountingService';

class ComprehensiveJournalService {
  // Create comprehensive journal entries from all transaction types
  async createComprehensiveJournalEntries(schoolID, startDate, endDate, reduxData) {
    try {
      const financialData = await comprehensiveAccountingDataService.getComprehensiveFinancialData(
        schoolID, startDate, endDate, reduxData
      );
      
      const journalEntries = [];

      // 1. School Fees Collection (by class)
      Object.values(financialData.classWiseData).forEach(classInfo => {
        if (classInfo.schoolFees.total > 0) {
          journalEntries.push({
            entryNumber: `SF-${classInfo.classname}-${Date.now()}`,
            date: new Date(),
            description: `School Fees Collection - ${classInfo.classname}`,
            entries: [
              {
                accountCode: '1000',
                accountName: 'Cash and Cash Equivalents',
                debit: classInfo.schoolFees.total,
                credit: 0
              },
              {
                accountCode: '4000',
                accountName: 'School Fees Revenue',
                debit: 0,
                credit: classInfo.schoolFees.total
              }
            ],
            debitTotal: classInfo.schoolFees.total,
            creditTotal: classInfo.schoolFees.total,
            schoolID,
            createdBy: 'system',
            userName: 'System'
          });
        }
      });

      // 2. Admission Fees Collection
      if (financialData.chargesData.admissionFees.total > 0) {
        journalEntries.push({
          entryNumber: `ADM-${Date.now()}`,
          date: new Date(),
          description: 'Admission Fees Collection',
          entries: [
            {
              accountCode: '1000',
              accountName: 'Cash and Cash Equivalents',
              debit: financialData.chargesData.admissionFees.total,
              credit: 0
            },
            {
              accountCode: '4200',
              accountName: 'Admission Fee Revenue',
              debit: 0,
              credit: financialData.chargesData.admissionFees.total
            }
          ],
          debitTotal: financialData.chargesData.admissionFees.total,
          creditTotal: financialData.chargesData.admissionFees.total,
          schoolID,
          createdBy: 'system',
          userName: 'System'
        });
      }

      // 3. Printing Fees Collection
      if (financialData.chargesData.printingFees.total > 0) {
        journalEntries.push({
          entryNumber: `PRT-${Date.now()}`,
          date: new Date(),
          description: 'Printing Fees Collection',
          entries: [
            {
              accountCode: '1000',
              accountName: 'Cash and Cash Equivalents',
              debit: financialData.chargesData.printingFees.total,
              credit: 0
            },
            {
              accountCode: '4210',
              accountName: 'Printing Fee Revenue',
              debit: 0,
              credit: financialData.chargesData.printingFees.total
            }
          ],
          debitTotal: financialData.chargesData.printingFees.total,
          creditTotal: financialData.chargesData.printingFees.total,
          schoolID,
          createdBy: 'system',
          userName: 'System'
        });
      }

      // 4. Books Revenue
      if (financialData.chargesData.booksCharges.total > 0) {
        journalEntries.push({
          entryNumber: `BKS-${Date.now()}`,
          date: new Date(),
          description: 'Books Revenue',
          entries: [
            {
              accountCode: '1000',
              accountName: 'Cash and Cash Equivalents',
              debit: financialData.chargesData.booksCharges.total,
              credit: 0
            },
            {
              accountCode: '4220',
              accountName: 'Books Revenue',
              debit: 0,
              credit: financialData.chargesData.booksCharges.total
            }
          ],
          debitTotal: financialData.chargesData.booksCharges.total,
          creditTotal: financialData.chargesData.booksCharges.total,
          schoolID,
          createdBy: 'system',
          userName: 'System'
        });
      }

      // 5. Uniform Revenue
      if (financialData.chargesData.uniformCharges.total > 0) {
        journalEntries.push({
          entryNumber: `UNI-${Date.now()}`,
          date: new Date(),
          description: 'Uniform Revenue',
          entries: [
            {
              accountCode: '1000',
              accountName: 'Cash and Cash Equivalents',
              debit: financialData.chargesData.uniformCharges.total,
              credit: 0
            },
            {
              accountCode: '4230',
              accountName: 'Uniform Revenue',
              debit: 0,
              credit: financialData.chargesData.uniformCharges.total
            }
          ],
          debitTotal: financialData.chargesData.uniformCharges.total,
          creditTotal: financialData.chargesData.uniformCharges.total,
          schoolID,
          createdBy: 'system',
          userName: 'System'
        });
      }

      // 6. Canteen Revenue
      if (financialData.chargesData.canteenFees.total > 0) {
        journalEntries.push({
          entryNumber: `CAN-${Date.now()}`,
          date: new Date(),
          description: 'Canteen Revenue',
          entries: [
            {
              accountCode: '1000',
              accountName: 'Cash and Cash Equivalents',
              debit: financialData.chargesData.canteenFees.total,
              credit: 0
            },
            {
              accountCode: '4100',
              accountName: 'Canteen Revenue',
              debit: 0,
              credit: financialData.chargesData.canteenFees.total
            }
          ],
          debitTotal: financialData.chargesData.canteenFees.total,
          creditTotal: financialData.chargesData.canteenFees.total,
          schoolID,
          createdBy: 'system',
          userName: 'System'
        });
      }

      // 7. Daily Charges Revenue
      if (financialData.chargesData.dailyCharges.total > 0) {
        journalEntries.push({
          entryNumber: `DAL-${Date.now()}`,
          date: new Date(),
          description: 'Daily Charges Revenue',
          entries: [
            {
              accountCode: '1000',
              accountName: 'Cash and Cash Equivalents',
              debit: financialData.chargesData.dailyCharges.total,
              credit: 0
            },
            {
              accountCode: '4250',
              accountName: 'Daily Charges Revenue',
              debit: 0,
              credit: financialData.chargesData.dailyCharges.total
            }
          ],
          debitTotal: financialData.chargesData.dailyCharges.total,
          creditTotal: financialData.chargesData.dailyCharges.total,
          schoolID,
          createdBy: 'system',
          userName: 'System'
        });
      }

      // 8. Weekly Charges Revenue
      if (financialData.chargesData.weeklyCharges.total > 0) {
        journalEntries.push({
          entryNumber: `WKL-${Date.now()}`,
          date: new Date(),
          description: 'Weekly Charges Revenue',
          entries: [
            {
              accountCode: '1000',
              accountName: 'Cash and Cash Equivalents',
              debit: financialData.chargesData.weeklyCharges.total,
              credit: 0
            },
            {
              accountCode: '4260',
              accountName: 'Weekly Charges Revenue',
              debit: 0,
              credit: financialData.chargesData.weeklyCharges.total
            }
          ],
          debitTotal: financialData.chargesData.weeklyCharges.total,
          creditTotal: financialData.chargesData.weeklyCharges.total,
          schoolID,
          createdBy: 'system',
          userName: 'System'
        });
      }

      // 9. Monthly Charges Revenue
      if (financialData.chargesData.monthlyCharges.total > 0) {
        journalEntries.push({
          entryNumber: `MTH-${Date.now()}`,
          date: new Date(),
          description: 'Monthly Charges Revenue',
          entries: [
            {
              accountCode: '1000',
              accountName: 'Cash and Cash Equivalents',
              debit: financialData.chargesData.monthlyCharges.total,
              credit: 0
            },
            {
              accountCode: '4270',
              accountName: 'Monthly Charges Revenue',
              debit: 0,
              credit: financialData.chargesData.monthlyCharges.total
            }
          ],
          debitTotal: financialData.chargesData.monthlyCharges.total,
          creditTotal: financialData.chargesData.monthlyCharges.total,
          schoolID,
          createdBy: 'system',
          userName: 'System'
        });
      }

      // 10. Termly Charges Revenue
      if (financialData.chargesData.termlyCharges.total > 0) {
        journalEntries.push({
          entryNumber: `TRM-${Date.now()}`,
          date: new Date(),
          description: 'Termly Charges Revenue',
          entries: [
            {
              accountCode: '1000',
              accountName: 'Cash and Cash Equivalents',
              debit: financialData.chargesData.termlyCharges.total,
              credit: 0
            },
            {
              accountCode: '4280',
              accountName: 'Termly Charges Revenue',
              debit: 0,
              credit: financialData.chargesData.termlyCharges.total
            }
          ],
          debitTotal: financialData.chargesData.termlyCharges.total,
          creditTotal: financialData.chargesData.termlyCharges.total,
          schoolID,
          createdBy: 'system',
          userName: 'System'
        });
      }

      // 11. Other Charges Revenue
      if (financialData.chargesData.otherCharges.total > 0) {
        journalEntries.push({
          entryNumber: `OTH-${Date.now()}`,
          date: new Date(),
          description: 'Other Charges Revenue',
          entries: [
            {
              accountCode: '1000',
              accountName: 'Cash and Cash Equivalents',
              debit: financialData.chargesData.otherCharges.total,
              credit: 0
            },
            {
              accountCode: '4240',
              accountName: 'Other Charges Revenue',
              debit: 0,
              credit: financialData.chargesData.otherCharges.total
            }
          ],
          debitTotal: financialData.chargesData.otherCharges.total,
          creditTotal: financialData.chargesData.otherCharges.total,
          schoolID,
          createdBy: 'system',
          userName: 'System'
        });
      }

      // 12. Discounts Given (Contra Revenue)
      if (financialData.chargesData.discounts.total > 0) {
        journalEntries.push({
          entryNumber: `DIS-${Date.now()}`,
          date: new Date(),
          description: 'Discounts Given',
          entries: [
            {
              accountCode: '4300',
              accountName: 'Discounts Given',
              debit: financialData.chargesData.discounts.total,
              credit: 0
            },
            {
              accountCode: '1000',
              accountName: 'Cash and Cash Equivalents',
              debit: 0,
              credit: financialData.chargesData.discounts.total
            }
          ],
          debitTotal: financialData.chargesData.discounts.total,
          creditTotal: financialData.chargesData.discounts.total,
          schoolID,
          createdBy: 'system',
          userName: 'System'
        });
      }

      // 13. Salaries and Wages
      if (financialData.salaries?.totalSalaries > 0) {
        journalEntries.push({
          entryNumber: `SAL-${Date.now()}`,
          date: new Date(),
          description: 'Salaries and Wages',
          entries: [
            {
              accountCode: '5000',
              accountName: 'Salaries and Wages',
              debit: financialData.salaries.totalSalaries,
              credit: 0
            },
            {
              accountCode: '1000',
              accountName: 'Cash and Cash Equivalents',
              debit: 0,
              credit: financialData.salaries.totalSalaries
            }
          ],
          debitTotal: financialData.salaries.totalSalaries,
          creditTotal: financialData.salaries.totalSalaries,
          schoolID,
          createdBy: 'system',
          userName: 'System'
        });
      }

      // 14. Operating Expenses
      if (financialData.expenditure?.totalAmount > 0) {
        journalEntries.push({
          entryNumber: `EXP-${Date.now()}`,
          date: new Date(),
          description: 'Operating Expenses',
          entries: [
            {
              accountCode: '5100',
              accountName: 'Administrative Expenses',
              debit: financialData.expenditure.totalAmount,
              credit: 0
            },
            {
              accountCode: '1000',
              accountName: 'Cash and Cash Equivalents',
              debit: 0,
              credit: financialData.expenditure.totalAmount
            }
          ],
          debitTotal: financialData.expenditure.totalAmount,
          creditTotal: financialData.expenditure.totalAmount,
          schoolID,
          createdBy: 'system',
          userName: 'System'
        });
      }

      // 15. Sales Revenue
      if (financialData.sales?.totalRevenue > 0) {
        journalEntries.push({
          entryNumber: `SAL-${Date.now()}`,
          date: new Date(),
          description: 'Sales Revenue',
          entries: [
            {
              accountCode: '1000',
              accountName: 'Cash and Cash Equivalents',
              debit: financialData.sales.totalRevenue,
              credit: 0
            },
            {
              accountCode: '4100',
              accountName: 'Canteen Revenue',
              debit: 0,
              credit: financialData.sales.totalRevenue
            }
          ],
          debitTotal: financialData.sales.totalRevenue,
          creditTotal: financialData.sales.totalRevenue,
          schoolID,
          createdBy: 'system',
          userName: 'System'
        });
      }

      return journalEntries;
    } catch (error) {
      console.error('Error creating comprehensive journal entries:', error);
      throw error;
    }
  }

  // Save journal entries to backend
  async saveJournalEntries(journalEntries) {
    try {
      const savedEntries = [];
      
      for (const entry of journalEntries) {
        try {
          const response = await accountingService.createJournalEntry(entry);
          savedEntries.push(response);
        } catch (error) {
          console.error(`Error saving journal entry ${entry.entryNumber}:`, error);
          // Continue with other entries even if one fails
        }
      }
      
      return savedEntries;
    } catch (error) {
      console.error('Error saving journal entries:', error);
      throw error;
    }
  }

  // Generate comprehensive financial summary
  async generateFinancialSummary(schoolID, startDate, endDate, reduxData) {
    try {
      const financialData = await comprehensiveAccountingDataService.getComprehensiveFinancialData(
        schoolID, startDate, endDate, reduxData
      );

      // Calculate total revenue from all sources
      const totalRevenue = 
        Object.values(financialData.classWiseData).reduce((sum, classInfo) => sum + classInfo.schoolFees.total, 0) +
        financialData.chargesData.admissionFees.total +
        financialData.chargesData.printingFees.total +
        financialData.chargesData.booksCharges.total +
        financialData.chargesData.uniformCharges.total +
        financialData.chargesData.canteenFees.total +
        financialData.chargesData.dailyCharges.total +
        financialData.chargesData.weeklyCharges.total +
        financialData.chargesData.monthlyCharges.total +
        financialData.chargesData.termlyCharges.total +
        financialData.chargesData.otherCharges.total +
        (financialData.sales?.totalRevenue || 0);

      // Calculate total expenses
      const totalExpenses = 
        (financialData.salaries?.totalSalaries || 0) +
        (financialData.expenditure?.totalAmount || 0);

      // Calculate net income
      const netIncome = totalRevenue - totalExpenses - financialData.chargesData.discounts.total;

      return {
        totalRevenue,
        totalExpenses,
        discounts: financialData.chargesData.discounts.total,
        netIncome,
        classWiseBreakdown: financialData.classWiseData,
        chargesBreakdown: financialData.chargesData,
        period: { startDate, endDate },
        generatedAt: new Date().toISOString()
      };
    } catch (error) {
      console.error('Error generating financial summary:', error);
      throw error;
    }
  }
}

export default new ComprehensiveJournalService();
